
export type SearchChatUsersParams = {
/**
 * Text to match user names or usernames
 */
query: string;
page?: number;
size?: number;
};
